import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder,faFileAlt } from '@fortawesome/free-solid-svg-icons'

// Example: Customising The Header Decorator To Include Icons
const Header = ({onSelect, style, customStyles, node}) => {
    const iconType = node.children ? 'faFolder' : 'faFileAlt';
    const iconClass = `fa fa-${iconType}`;
    const iconStyle = {marginRight: '5px', marginTop: '10px'};
    const iconStyle2 = {marginRight: '5px'};

    return (
        <div style={style.base} onClick={()=>node.onSelect(node)}>
        {/*<div style={style.base}>*/}
            <div className="treeheader" style={node.selected ? {...style.title, color:"yellow"} : style.title}>
                {/*<i className={iconClass} style={iconStyle}/>*/}
                {node.children && node.toggled &&(
                  <FontAwesomeIcon icon={faFolder} style={iconStyle2}/>
                )}
                {node.children && !node.toggled &&(
                  <FontAwesomeIcon icon={faFolder} style={iconStyle} />
                )}

                {!node.children && node.toggled &&(
                  <FontAwesomeIcon icon={faFileAlt} style={iconStyle2} />
                )}
                {!node.children && !node.toggled &&(
                  <FontAwesomeIcon icon={faFileAlt} style={iconStyle} />
                )}
              {node.name}
            </div>
        </div>
    );
};

Header.propTypes = {
    onSelect: PropTypes.func,
    node: PropTypes.object,
    style: PropTypes.object,
    customStyles: PropTypes.object
};

Header.defaultProps = {
    customStyles: {}
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/views/SrcView/Header.js